// The single field-type _id that represents a "dropdown" field.
export const DROPDOWN_FIELD_TYPE_ID = "68df9d4824a7350632b4aedf";

export interface FieldType {
  _id: string;
  name: string;
}

export interface CustomFormField {
  _id?: string;
  fieldName?: string;
  fieldType?: string;
  description?: string;
  defaultValue?: string;
  required?: boolean;
  isUnique?: boolean;
  active?: boolean;
  dropdownOptions?: string[];
}

export interface FieldErrors {
  fieldName?: string;
  fieldType?: string;
  description?: string;
  options?: string;
}